module.exports = __webpack_public_path__ + "img/24.5495835c.jpg";